/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CompositeProductType = {
    SINGLE: 'SINGLE',
    COMBO: 'COMBO'
} as const;
export type CompositeProductType = typeof CompositeProductType[keyof typeof CompositeProductType];

